import {contentItemAction} from '../../actions/contentItemActions';
import {menuAction} from '../../actions/menuActions';

export interface BlindMapState {
  guessedIncorrectly: boolean;
}

const initialState: BlindMapState = {
  guessedIncorrectly: false,
};

export function blindMapReducer(state: BlindMapState = initialState, action: any): BlindMapState {
  switch (action.type) {
    case contentItemAction.Quiz_BlindMapIncorrectHit:
      return {
        guessedIncorrectly: true,
      };
    case contentItemAction.Quiz_SubmitAnswer:
    case contentItemAction.SequencedContent_Finish_Selected:
    case menuAction.SideMenu_DeselectItem:
    case menuAction.SideMenu_NavigateBack:
    case menuAction.SideMenu_SelectedSubmenuItem:
    case menuAction.SideMenu_SelectNonSequencedFlowItem:
    case menuAction.SideMenu_SelectSequencedFlowItem:
      return initialState;
    default:
      return state;
  }
}
